import { KeyboardEvent } from 'react';

type PositiveNumberProps = {
  min?: number;
  step?: number;
};

export const positiveNumber = (props?: PositiveNumberProps) => {
  const { min = 0, step = 0.1 } = props ? props : {};
  return {
    type: 'number',
    inputProps: {
      min,
      step,
    },
    onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => {
      if (!/^[\d.]+$/.test(event.key) && event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey)
        event.preventDefault();
    },
  };
};
